import React from 'react';
import type { Problem } from '../data/problems';

type Language = 'javascript' | 'typescript' | 'python';

const LABELS: Record<Language, string> = {
  javascript: 'JavaScript',
  typescript: 'TypeScript',
  python: 'Python',
};

interface Props {
  problem: Problem;
  language: Language;
  isAllowed: (problem: Problem, lang: Language) => boolean;
  onPick: (lang: Language) => void;
}

// The language tab strip. A tab is disabled (greyed, not clickable) when the
// problem doesn't support that language.
const IdeLanguageTabs: React.FC<Props> = ({ problem, language, isAllowed, onPick }) => (
  <div className="ide-lang-tabs">
    {(['javascript', 'typescript', 'python'] as Language[]).map(lang => {
      const allowed = isAllowed(problem, lang);
      return (
        <button
          key={lang}
          className={`ide-lang-tab ${language === lang ? 'active' : ''}`}
          onClick={() => allowed && onPick(lang)}
          disabled={!allowed}
          title={allowed ? undefined : `Not yet supported in ${LABELS[lang]}`}
          style={!allowed ? { opacity: 0.45, cursor: 'not-allowed' } : undefined}
        >
          {LABELS[lang]}
        </button>
      );
    })}
    {problem.supportedLanguages && !problem.supportedLanguages.includes('javascript') && (
      <span className="sk-pill amber" style={{ fontSize: 10, marginLeft: 8 }}>
        Python only
      </span>
    )}
  </div>
);

export default IdeLanguageTabs;
